<template>
	<div class="navs">
		<div class="w1228 df">
			<div class="btn" :class="{ cur: page==v.page }" @click="tapNav(v.page)" v-for="(v,i) in nav">{{v.name}}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'navs',
	props: {
		page: {
			default: '',
		},
	},
	data () {
		return {
			nav: [
				{ name: '首页', page: 'index' },
				{ name: '商城', page: 'shop' },
				{ name: '云智饮片公司', page: 'company' },
				{ name: '产品中心', page: 'product' },
				{ name: '学术推广', page: 'study' },
			],
		}
	},
	methods: {
		tapNav(page){
			if(this.$route.name!=page){
				this.$api.toPage(page)
			}
		},
	},
}
</script>

<style lang="less" scoped>
	.navs{
		background: #019370;
		.btn{
			min-width: 120px;
			text-align: center;
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 16px;
			color: #FFFFFF;
			line-height: 46px;
			padding: 0 10px;
			margin-right: 20px;
			transition: all 0.2s ease-in-out;
			&:hover{
				background: #1ea081;
			}
			&.cur{
				background: #1ea081;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/navs/navs.vue